import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1eb2a6", // here
        secondary: "#d4f8e8", // here
        accent: "#f67575", // here
        error: "#FF5252",
        info: "#413F41", // text
        success: "#4CAF50",
        warning: "#ffa34d", // here
      },
    },
  },
});
